<template>
    <div class="ml-notice">
        <router-link :to="link" class="link">
            <span>
                <strong class="points">·</strong>
                <slot></slot>
            </span>
            <span class="date"> [{{ date }}] </span>
        </router-link>
    </div>
</template>

<script>
export default {
    props: {
        link: {
            type: String,
            default: ""
        },
        date: {
            type: String,
            default: ""
        }
    }
};
</script>

<style lang="scss" scoped>
.ml-notice {
    position: relative;

    .link {
        display: block;
        width: 100%;
        color: #000;

        span:first-child {
            display: inline-block;
            width: calc(100% - 92px);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: keep-all;
        }

        .points {
            margin-right: 5px;
        }

        .date {
            float: right;
            color: $ml-blue;
        }
    }
}
</style>
